// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__GRLmS","ranges":"BmiRanges_ranges__2ACsa"};